import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import { DefaultSettingPont } from '../constants';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getIsBitSet, setBit, } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
export default function saveDefaultSettings() {
    var config = getUserConfiguration();
    // Try to update the React settings
    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['GlobalReadingPanePositionReact'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: ["" + config.UserOptions.GlobalReadingPanePositionReact],
            }),
        }),
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['ConversationSortOrderReact'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: ["" + getConversationSortOrderValue(config)],
            }),
        }),
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['GlobalListViewTypeReact'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: ["" + config.UserOptions.GlobalListViewTypeReact],
            }),
        }),
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['NewEnabledPonts'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: ["" + (config.UserOptions.NewEnabledPonts & ~DefaultSettingPont)],
            }),
        }),
    ]).then(function (response) {
        // If successfully initialized settings and the user is commercial and it's their first time in React (IsCommercialUserInitialized is false), set IsCommercialUserInitialized
        // bit to true so next time we use their React settings since they've already been initialized with the right values
        if (response.Body.ResponseMessages.Items[0].ResponseClass === 'Success' &&
            !isConsumer() &&
            !getIsBitSet(32 /* IsCommercialUserInitialized */)) {
            setBit(true /* IsCommercialUserInitialized */, 32 /* IsCommercialUserInitialized */);
            updateUserConfiguration('OWA.ViewStateConfiguration', [
                userConfigurationDictionaryEntry({
                    DictionaryKey: userConfigurationDictionaryObject({
                        Type: 'String',
                        Value: ['ListViewBitFlags'],
                    }),
                    DictionaryValue: userConfigurationDictionaryObject({
                        Type: 'Integer32',
                        Value: ["" + config.ViewStateConfiguration.ListViewBitFlags],
                    }),
                }),
            ]);
        }
    });
}
function getConversationSortOrderValue(config) {
    var conversationSortOrderValue;
    switch (config.UserOptions.ConversationSortOrderReact) {
        case 'Chronological':
            conversationSortOrderValue = 0x1;
            break;
        case 'Tree':
            conversationSortOrderValue = 0x2;
            break;
        case 'NewestOnTop':
            conversationSortOrderValue = 0x4;
            break;
        case 'NewestOnBottom':
            conversationSortOrderValue = 0x8;
            break;
        case 'ChronologicalNewestOnTop':
            conversationSortOrderValue = 0x5;
            break;
        case 'ChronologicalNewestOnBottom':
            conversationSortOrderValue = 0x9;
            break;
        case 'TreeNewestOnBottom':
            conversationSortOrderValue = 0xa;
            break;
    }
    return conversationSortOrderValue;
}
//# sourceMappingURL=saveDefaultSettings.js.map